import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    presupuestosGastos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    nombre: '',
    incluirInactivos: false,

    comparativoPeriodoAnterior: '',
    comparativoPeriodoActual: '',
    comparativoPeriodoPosterior: '',
    comparativoRenglones: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.articulosTipos = [];
    },
    'SET_PRESUPUESTOS'(state, presupuestosGastos) {
        state.presupuestosGastos = presupuestosGastos;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_COMPARATIVO'(state) {
        state.comparativoPeriodoAnterior = '1900-01-01';
        state.comparativoPeriodoActual = '1900-01-01';
        state.comparativoPeriodoPosterior = '1900-01-01';
        state.comparativoRenglones = [];
    },
    'SET_COMPARATIVO'(state, comparativo) {
        state.comparativoPeriodoAnterior = comparativo.periodoAnterior;
        state.comparativoPeriodoActual = comparativo.periodoActual;
        state.comparativoPeriodoPosterior = comparativo.periodoPosterior;
        state.comparativoRenglones = comparativo.renglones.map(renglon => ({
            ...renglon,
            _rowVariant: (parseFloat(renglon.pjeIncrementoActual) == 0? 'n' : (parseFloat(renglon.pjeIncrementoActual) < 0? 'v' : 'r'))
                + '-' + (parseFloat(renglon.pjeIncrementoPosterior) == 0? 'n' : (parseFloat(renglon.pjeIncrementoPosterior) < 0? 'v' : 'r'))
        }));

        let totalAnterior = comparativo.renglones.reduce((total, renglon) => {
                return total + parseFloat(renglon.importeAnterior);
            }, 0);

        let totalActual = comparativo.renglones.reduce((total, renglon) => {
                return total + parseFloat(renglon.importeActual);
            }, 0);

        let totalPosterior = comparativo.renglones.reduce((total, renglon) => {
                return total + parseFloat(renglon.importePosterior);
            }, 0);

        let pjeIncrementoActual = 0;
        if (totalAnterior != 0 && totalActual != 0) {
            pjeIncrementoActual =  helpers.methods.roundToTwo((totalActual - totalAnterior) / totalAnterior * 100);
        }
    
        let pjeIncrementoPosterior = 0;
        if (totalActual != 0 && totalPosterior != 0) {
            pjeIncrementoPosterior =  helpers.methods.roundToTwo((totalPosterior - totalActual) / totalActual * 100);
        }


        state.comparativoRenglones.push({
            presupuestoGastosConceptoId: -1,
            presupuestoGastosConcepto: 'TOTALES',
            importeAnterior: totalAnterior,
            importeActual: totalActual,
            pjeIncrementoActual,
            importePosterior: totalPosterior,
            pjeIncrementoPosterior,
            _rowVariant: 'totales'
        })
    },
};

const actions = {
    getPresupuestosGastos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            apiAxios.get('presupuestos-gastos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_PRESUPUESTOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getPresupuestosGastosComparativo: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COMPARATIVO')

            apiAxios.get('presupuestos-gastos/comparativo')
                .then(res => {
                    commit('SET_COMPARATIVO', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, presupuestoGastosId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestos-gastos/${presupuestoGastosId}/delete`)
                .then(() => resolve())
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    }   
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}